import { createFileRoute } from '@tanstack/react-router';

import { OnboardingTab } from '@apps/web/components/training/onboarding_tab';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';

export const Route = createFileRoute('/_app/(main)/training/onboarding')({
    component: OnboardingRoute,
});

function OnboardingRoute() {
    const organizationId = useOrganizationId();

    if (!organizationId) {
        return (
            <div className="text-muted-foreground text-sm">
                Select an organization to configure onboarding.
            </div>
        );
    }

    return <OnboardingTab organizationId={organizationId} />;
}
